module.exports = __webpack_public_path__ + "img/ic_star_empty.1f54b8da.svg";